import { useEffect, useState } from "react";
import api from "../../../api";
import { Autobooking, HttpError } from "../../../api/types";

/**
 * Custom hook to fetch autobookings from backend.
 * @returns {object} - Contains autobookings, loading state, error state, and refetch function.
 */
function useFetchAutobookings() {
  const [autobookings, setAutobookings] = useState<Autobooking[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<HttpError | null>(null);

  const fetchAutobookings = async () => {
    setLoading(true);
    setError(null);

    try {
      const autobookings = (await api.getAutobookings()) || [];

      if (api.error) {
        setError(api.error);
      }

      setAutobookings(autobookings);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAutobookings();
  }, []);

  return { autobookings, loading, error, refetchAutobookings: fetchAutobookings };
}

export default useFetchAutobookings;
